<div fxLayout="row" fxLayoutAlign="start center">
	<!--  Toggle switch visible only to the Admin  -->
	<div
		*ngIf="isLoggedInUserAdmin && !hideToggleSwitch"
		fxLayout="row"
		fxLayoutAlign="start center"
	>
		<mat-slide-toggle
			[(ngModel)]="showDonorList"
			(change)="onToggleChange($event)"
			id="hide_donor_list_toggle"
			color="primary"
		>
			<div fxLayout="row" fxLayoutAlign="start center">
				<span i18n="@@donor_list_show_donation_received"
					>Show Donation Recieved</span
				>
				&nbsp;
			</div>
		</mat-slide-toggle>
		<img
		    class="p-l-s"
			matTooltip="{{ this.tooltip }}"
			src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
		/>
	</div>
</div>

<div fxLayout="row" fxLayoutAlign="start center" ngClass="m-t-m">
	<div fxLayout="column" fxLayoutAlign="center center">
		<div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="5%">
			<div fxLayout="column">
				<span class="whydonate-light xxl-icon">
					<img
						ngClass="m-l-xs"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donation-support/public"
					/>
				</span>
			</div>
			<div fxLayout="column" fxLayoutGap="3%">
				<div class="mat-headline-6" i18n="@@donations_zero_donation_heading">
					Donation
				</div>
				<div i18n="@@donations_zero_supportYourCause_label">
					Support your cause by being the first donor.
				</div>
			</div>
		</div>
	</div>
</div>
<div
	fxLayout="column"
	fxFill
	ngClass="pale-grey-bg p-m m-t-m"
	*ngIf="isLoggedIn; else loggedOutTemplate"
>
	<div fxLayout="row" fxLayoutGap="4%" fxLayoutAlign="start center">
		<div>
			<h2 i18n="@@offline_collection_heading">Offline Collection</h2>
		</div>
		<div ngClass="p-b-xs">
			<img
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
				matTooltip="{{ this.offlineDonationTooltip }}"
			/>
		</div>
	</div>
	<div fxLayout="column" fxLayoutGap="2%">
		<div
			[matTooltip]="addOfflineDonationTooltip"
			[matTooltipDisabled]="!isDraftOrClosed"
		>
			<button
				*ngIf="isLoggedInUserAdmin && !isWholePreview"
				mat-stroked-button
				color="accent"
				class="hover-btn w-100"
				[disabled]="isDraftOrClosed"
				(click)="addOfflineDonation()"
				i18n="@@button_add_offline_donation"
			>
				Add Offline Donation
			</button>
		</div>
		<div [matTooltip]="viewSummaryTooltip" [matTooltipDisabled]="isViewSummary">
			<button
				mat-stroked-button
				color="accent"
				class="hover-btn w-100"
				[disabled]="!isViewSummary"
				i18n="@@button_view_summary"
				(click)="viewOfflineDonationSummary()"
			>
				View Summary
			</button>
		</div>
	</div>
</div>
<ng-template #loggedOutTemplate>
	<div
		fxLayout="column"
		fxFill
		ngClass="pale-grey-bg p-m m-t-m"
		*ngIf="isViewSummary"
	>
		<div fxLayout="row" fxLayoutGap="4%" fxLayoutAlign="start center">
			<div>
				<h2 i18n="@@offline_collection_heading">Offline Collection</h2>
			</div>
			<div ngClass="p-b-xs">
				<img
					src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
					matTooltip="{{ this.offlineDonationTooltip }}"
				/>
			</div>
		</div>
		<div fxLayout="column" fxLayoutGap="2%">
			<p *ngIf="!isLoggedIn">
				{{ currency_symbol }}&nbsp;{{ totalOfflineDonationAmount }}
				<span
					class="mat-typography"
					i18n="@@offline_donation_collected_by_cause"
					>was collected offline by the cause</span
				>
			</p>
			<div
				[matTooltip]="viewSummaryTooltip"
				[matTooltipDisabled]="isViewSummary"
			>
				<button
					mat-stroked-button
					color="accent"
					class="hover-btn w-100"
					[disabled]="!isViewSummary"
					i18n="@@button_view_summary"
					(click)="viewOfflineDonationSummary()"
				>
					View Summary
				</button>
			</div>
		</div>
	</div>
</ng-template>
